import React from "react";
import { useParams } from "react-router-dom";
import VendorDeviceDashboard from "./VendorDeviceDashboard";

function VendorDeviceDashboardWrapper() {
    const { deviceId } = useParams();

    return <VendorDeviceDashboard deviceId={deviceId} />;
}

export default VendorDeviceDashboardWrapper;